import { CommunityChannelApi } from '@ps/api/community-channel';
import type {
  CommunityChannelVisibilityEnumItem,
  PopStoreExtendedSubscriptionLevelEnumItem,
} from '@ps/api/types';
import { withClientAPI } from '@ps/functions/utils/api';

/**
 * Full-update of a channel — name / description / visibility / icon
 * / subscription level / broadcast. When the minimum subscription
 * level is being raised, the caller decides whether to grandfather
 * existing members (`applySubscriptionLevelToNewMembersOnly: true`)
 * or apply the new requirement to everyone.
 */
export async function updateChannel({
  creatorId,
  channelId,
  name,
  description,
  visibility,
  icon,
  minimumSubscriptionLevel,
  isBroadcastChannel,
  applySubscriptionLevelToNewMembersOnly = true,
}: {
  creatorId: string;
  channelId: string;
  name: string;
  description?: string;
  visibility: CommunityChannelVisibilityEnumItem;
  icon: string;
  minimumSubscriptionLevel: PopStoreExtendedSubscriptionLevelEnumItem;
  isBroadcastChannel?: boolean;
  applySubscriptionLevelToNewMembersOnly?: boolean;
}): Promise<void> {
  const api = withClientAPI(CommunityChannelApi);
  await api.communityChannelApiControllerUpdateCommunityChannel({
    sellerId: creatorId,
    channelId,
    UpdateCommunityChannelRequest: {
      icon,
      name,
      description,
      visibility,
      minimumSubscriptionLevel,
      isBroadcastChannel,
      applySubscriptionLevelToNewMembersOnly,
    },
  });
}
